import { createContext, useContext, useState } from "react";
import { SAMPLE_TB, processTB } from "data/finopsData";

const FinOpsContext = createContext(null);

export function FinOpsProvider({ children, uiTheme, setUiTheme, clientCompany, clientPeriod }) {
  const [tbRows, setTbRows] = useState([]);
  const [company, setCompany] = useState(clientCompany || "Your Company");
  const [period, setPeriod] = useState(clientPeriod || "Year Ended 31 December 2025");
  const [isUploaded, setIsUploaded] = useState(false);
  const [customMapping, setCustomMapping] = useState(null);

  const fsData = processTB(tbRows, customMapping);

  function loadTB(rows, companyName, periodLabel, mapping) {
    setTbRows(rows);
    if (companyName) setCompany(companyName);
    if (periodLabel) setPeriod(periodLabel);
    if (mapping) setCustomMapping(mapping);
    setIsUploaded(true);
  }

  return (
    <FinOpsContext.Provider value={{ tbRows, fsData, company, period, isUploaded, loadTB, uiTheme, setUiTheme }}>
      {children}
    </FinOpsContext.Provider>
  );
}

export function useFinOps() {
  return useContext(FinOpsContext);
}
